import { endOfWeek as endOfWeekFns } from 'date-fns';

export default function endOfWeek(date: Date, sundayStart?: boolean): Date {
  const weekStartsOn = sundayStart ? 0 : 1;
  return endOfWeekFns(date, { weekStartsOn });
}
